<template>

  <div class="d-flex flex-start flex-wrap gap align-center mb-3" v-if="display_switch_button">
    <div>Vous vous trouvez actuellement sur la billetterie non sportive. Pour vous inscrire à un
      parcours, suivez ce
      lien</div>
    <SportipsButton @onClick="leave_billetterie()" icon="mdi-arrow-right">Se rendre sur le module sportif
    </SportipsButton>
  </div>


</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
    display_switch_button() {
      return this.mainStore.billetterie_mode && this.$route.params.base_module.includes("BILLETTERIE_");
    }
  },
  methods: {
    leave_billetterie() {
      let base_module = this.$route.params.base_module;
      let base_module_sportif = base_module.replace("BILLETTERIE_", "");
      this.$router.push({ name: "Home", params: { base_module: base_module_sportif } });
    },
  },
};
</script>

<style lang="scss" scoped></style>